import styled from 'styled-components';

export const StyledPlayerLevel = styled.div<{ backgroundUrl?: string }>`
  font-family: var(--font-family);
  position: relative;
  display: flex;

  background: ${({ backgroundUrl }) =>
    backgroundUrl ? `url("${backgroundUrl}")` : ''};
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;

  padding: 3px 10px 3px 40px;
  justify-content: center;
  align-items: center;
  width: 245px;

  .timer-text {
    font-family: var(--font-family);
    font-weight: 600;
    text-transform: uppercase;
    font-size: 21px;
    color: white;
    text-shadow: 0px 1.5px 0px #000;
    text-align: center;
    width: 195px;
  }
`;
